import { routerBasePath } from "@/lib/appPaths";

const AUTH_ROUTE_PATHS = new Set(["/login", "/signup", "/forgot-password", "/reset-password"]);

export function stripQueryAndHash(path: string) {
  return path.split(/[?#]/, 1)[0] || "/";
}

export function isAuthRoutePath(path: string) {
  return AUTH_ROUTE_PATHS.has(stripQueryAndHash(path));
}

export function getCurrentAppLocation(fallback = "/") {
  if (typeof window === "undefined") {
    return fallback;
  }

  let pathname = window.location.pathname || "/";
  if (routerBasePath && pathname.startsWith(routerBasePath)) {
    pathname = pathname.slice(routerBasePath.length) || "/";
  }
  if (!pathname.startsWith("/")) {
    pathname = `/${pathname}`;
  }
  return `${pathname}${window.location.search || ""}${window.location.hash || ""}`;
}

export function sanitizeLoginReturnTo(value: string | null | undefined) {
  const candidate = (value || "").trim();
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//") || isAuthRoutePath(candidate)) {
    return "/";
  }
  return candidate;
}

export function buildLoginLocation(returnTo?: string | null) {
  return `/login?returnTo=${encodeURIComponent(sanitizeLoginReturnTo(returnTo || getCurrentAppLocation()))}`;
}
